export default "__VITE_ASSET__Nnh_tXzG__"